<template>
  <v-app-bar density="compact">
    <v-container class="mx-auto d-flex align-center justify-center">

      <v-btn size="x-small" v-on:click="newReport()">
        <template v-slot:prepend>
          <v-icon :icon="['fas', 'plus']" />
        </template>
        Создать новый
      </v-btn>
      <v-btn size="x-small" v-on:click="changeMode()" :color="SecretBooba ? 'red' : null">
        <template v-slot:prepend>
          <v-icon v-if="!mode" :icon="['fas', 'pen-to-square']" />
          <v-icon v-else :icon="['fas', 'eye']" />
        </template>

        <v-menu v-if="!mode" open-on-hover :open-delay="mode ? 15000 : 1000">
          <template v-slot:activator="{ props }">
            <span v-bind="props">Редактирование</span>
          </template>
          <v-card rounded="xl" min-width="400">
            <template v-slot:title>
              ДОП. ФУНКЦИИ
            </template>
            <template v-slot:actions>
              <v-switch inset v-model="show_dev_fields" label="ОТОБРАЖАТЬ ПОЛУЧАЕМЫЕ ДАННЫЕ" />
              <v-switch inset v-model="SecretBooba" label="ВКЛЮЧИТЬ ДОП.ФУНКЦИОНАЛ" />
            </template>
          </v-card>
        </v-menu>
        <span v-if="mode">Просмотр</span>
      </v-btn>
      <SaveReportDialog />
      <UpdateReportDialog />
      <v-spacer />
      <v-chip size="x-small" color="black" rounded="sm" variant="text">
        Отчёт для {{report_data['Заказчик']}} за период с {{ normal_date(range.start) }} по {{ normal_date(range.end) }}
      </v-chip>
      <v-btn v-on:click="gotoPrint()" style="color: #FF5722;" variant="text">
        <template v-slot:default>
          ПЕЧАТЬ ОТЧЁТА
        </template>
        <template v-slot:prepend>
          <v-icon :icon="['fas', 'print']" />
        </template>
      </v-btn>
    </v-container>
  </v-app-bar>
</template>

<script>
import { TokenGUIDStore } from "@/store/global/SessionStore";
import { Rep_Contract, Rep_Contracts, Rep_Edite_Mode, Rep_Period } from "@/store/report/SmallStorrage";
import { ReportData } from "@/store/report/ReportData";
import { isLoader } from "@/store/Loader";
import SaveReportDialog from "@/components/Reports/SaveReportDialog.vue";
import UpdateReportDialog from "@/components/Reports/UpdateReportDialog.vue";
import moment from "moment/moment";
import {SecretBooba} from "@/store/SecretBooba";
import {ShowDevVields} from "@/store/report/show_dev.store";
import {ItemData, ItemDesc, ItemName, ItemUUID} from "@/store/report/save.store";
export default {
  name: "ReportToolBelt__Edit",
  components: {UpdateReportDialog, SaveReportDialog },
  data() {
    return {
      shown: true,
      hasLogoImage: true
    }
  },
  computed: {
    normal_date() {
      return date => {
        return moment(date).format("DD.MM.YYYY")
      }
    },
    session_token() {
      return TokenGUIDStore().get()
    },
    isLoading: {
      get() {
        return isLoader().get()
      },
      set(value) {
        return isLoader().set(value)
      }
    },
    SecretBooba: {
      get() {
        return SecretBooba().get()
      },
      set(value) {
        return SecretBooba().set(value)
      }
    },
    show_dev_fields: {
      get() {
        return ShowDevVields().get()
      },
      set(value) {
        return ShowDevVields().set(value)
      }
    },
    contracts: {
      get() {
        return Rep_Contracts().get()
      },
      set(value) {
        Rep_Contracts().set(value)
      }
    },
    mode: {
      get() {
        return Rep_Edite_Mode().get()
      },
      set(value) {
        return Rep_Edite_Mode().set(value)
      }
    },
    contract: {
      get() {
        return Rep_Contract().get()
      },
      set(value) {
        Rep_Contract().set(value)
      }
    },
    report_data: {
      get() {
        return ReportData().get()
      },
      set(value) {
        ReportData().set(value)
      }
    },
    range: {
      get() {
        return Rep_Period().get()
      },
      set(value) {
        Rep_Period().set(value)
      }
    },
    preparedData() {
      return {
        ObjectGUID: this.contract,
        dateStart: this.range.start,
        dateEnd: this.range.end
      }
    },
    item_uuid: {
      get() {
        return ItemUUID().get()
      },
      set(value) {
        ItemUUID().set(value)
      }
    },
    item_name: {
      get() {
        return ItemName().get()
      },
      set(value) {
        ItemName().set(value)
      }
    },
    item_desc: {
      get() {
        return ItemDesc().get()
      },
      set(value) {
        ItemDesc().set(value)
      }
    },
    item_data: {
      get() {
        return ItemData().get()
      },
      set(value) {
        ItemData().set(value)
      }
    }
  },
  methods: {
    clear_local_storage: function () {
      this.item_uuid = null
      this.item_name = null
      this.item_desc = null
      this.item_data = null
    },
    getContractImage: function () {
      let image
      try {
        image = require(`@/components/Reports/images/reports/contracts/${this.contract}.png`)
      } catch (err) {
        this.hasLogoImage = false
        console.log(`%cВыбранный контракт не имеет загруженного логотипа!\n\n%c${this.contract}.png`, 'background: #f00; color: #fff', 'background: transparent; color: #000')
      }
      if (image) {
        this.hasLogoImage = true
        this.srcLogoImage = image
      }

      if (this.hasLogoImage) return image
      return null
    },
    saveReportInWEB: function () {

    },
    changeMode: function () {
      this.isLoading = true
      setTimeout(() => {
        this.mode = !this.mode
        this.isLoading = false
      }, 100)
    },
    gotoPrint: function () {
      this.isLoading = true
      this.$router.push({path: '/report/show'})
      setTimeout(() => {
        this.isLoading = false
      }, 100)
    },
    hide: function () {
      this.shown = false
    },
    newReport: function () {
      this.report_data = null
      this.clear_local_storage()
      this.clearContract()
      this.$router.push({path: '/report/create'})
    },
    clearDate: function () {
      this.range = null
    },
    clearContract: function () {
      this.contract = ''
      this.clearDate()
    },
    savePattern: function () {
      let pattern = []
      for (let section of this.report_data.section_list) {
        console.log(section)
        pattern.push({
          name: section.name,
          guid: section.guid,
          type: 'chart',
          groups: this.genGroups(section.groups)
        })
      }
      let to_string = {
        guid: this.report_data['GUID'],
        unused: this.report_data.unused,
        used: pattern
      }
      let text = JSON.stringify(to_string);
      downloadAsFile(text);
      function downloadAsFile(data) {
        let a = document.createElement("a");
        let file = new Blob([data], {type: 'application/json'});
        a.href = URL.createObjectURL(file);
        a.download = "pattern.json";
        a.click();
      }
      console.log('Сохранено')
    },
    genGroups: function (groups) {
      let group_list = []
      for (let group of groups) {
        group_list.push({
          guid: group.guid,
          name: group.name,
          page: group.page,
          reports: this.genReps(group.reports)
        })
      }
      return group_list
    },
    genReps: function (reports) {
      let report_list = []
      for (let report of reports) {
        report_list.push({
          id: report.id
        })
      }
      return report_list
    }
  }
}
</script>

<style scoped>

</style>
